import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    background: ${theme.colors.background.secondary.B};
    padding: 12px 20px;
    font-size: ${theme.fontSizes.C};
    font-family: ${theme.fonts.monospace};
    box-shadow: 0 1px 0 0 hsla(0, 0%, 0%, 0.03) inset;
    overflow: hidden;
    max-height: max-content;
    margin-top: 8px;
  `
)

export const LineContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Line = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  :not(:last-child) {
    margin-bottom: 4px;
  }
`

export const Property = styled.span`
  margin-right: 4px;
  white-space: nowrap;
`

export const Values = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.ui.inspector.code};
  flex-wrap: wrap;
`

export const Value = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
`

export const InnerValue = styled.span`
  white-space: nowrap;
`

export const ColorSwatch = styled.span<{
  background: string
  spaceLeft: boolean
}>`
  width: 13px;
  height: 13px;
  background: ${({ background }) => background};
  display: inline-flex;
  margin-right: 6px; /* stylelint-disable-line scales/space */
  ${({ spaceLeft }) =>
    spaceLeft && 'margin-left: 6px; /* stylelint-disable-line scales/space */'}
  border: 1px solid hsla(0, 0%, 18%, 0.15);
  border-radius: 3px;
`

export const Punctuation = styled.span`
  display: contents;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`
